; (function ($, window, document) {
    'use-strict';

    let currentLang = null;

    Foundation.libs.matyWeglot = {
        name: "matyWeglot",
        version: "1.0.0",
        settings: {
            callback: function () { }
        },

        init: function (scope, method, options) {
            // initialisation � conserver
            Foundation.inherit(this, 'throttle random_str');
            this.settings = this.settings || $.extend({}, this.defaults, (options || method));
            this.bindings(method, options);
        },

        initMatyWeglot: function () {
            // Weglot ne s'initialise pas instantan�ment et on n'a pas de hook qui permet d'initialiser correctement le cookie... donc on y va comme des sacs
            const langCookie = Foundation.libs.matyWeglot.getLangCookie();
            if (!langCookie || langCookie != currentLang) {
                Foundation.libs.matyWeglot.initLangCookie(0, 5, 100, Foundation.libs.matyWeglot.initLangCookie);
            }
        },

        initLangCookie: function (currentTry, maxTries, timeout, fallback) {
            //console.log("current lang : " + currentLang);
            Foundation.libs.matyWeglot.initCurrentLang();
            if (currentLang == null && currentTry < maxTries && fallback != null) {
                setTimeout(() => {
                    fallback(currentTry + 1, maxTries, timeout, fallback);
                }, timeout);
                return;
            } else {
                // On vient r�cup�rer tous les cookies du navigateur
                const allCookies = document.cookie.split(";");

                allCookies.forEach(cookie => {
                    const trimmed = cookie.trim();
                    // On vient check s'il n'y a pas d�j� un ou plusieurs cookies de lang
                    if (trimmed.startsWith("lang=")) {
                        // Et on les vire
                        // C'est un cas qui peut arriver si on ouvre plusieurs onglets dans plusieurs langues diff�rentes par exemple
                        document.cookie = "lang=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    }
                });

                document.cookie = `lang=${currentLang ?? 'fr'}; path=/; SameSite=Lax`;
                //console.log(document.cookie.split(";").find(c => c.includes("lang=")));
            }
        },

        initCurrentLang: function () {
            if (window.Weglot != undefined && window.Weglot != null && !currentLang) {
                const weglotLang = Weglot.getCurrentLang();
                currentLang = weglotLang ?? null;
            }
        },

        initObfuscatedLinks: (wrapper = document) => {
            const obfuscatedLinks = wrapper.querySelectorAll(".fbo");

            obfuscatedLinks.forEach(link => {
                link.addEventListener("click", () => Foundation.libs.matyWeglot.handleObfuscatedLinkClick(link))
            })
        },

        getLangCookie: () => {
            const cookies = document.cookie.split(";");
            const cookie = cookies.find(c => c.includes("lang="));

            if (!cookie) return null;

            const lang = cookie.split("=")[1];
            return lang;
        },

        handleObfuscatedLinkClick: (link) => {
            const b64Url = link.getAttribute("data-href");

            if (b64Url) {
                const decodedUrl = atob(b64Url);

                if (link.getAttribute("data-mastertag")) {
                    // G�rer ici s'il faut rajouter un tracking au clic
                    Foundation.libs.mastertag.trackObfuscatedLink(link.getAttribute("data-mastertag"), decodedUrl);
                }

                const newTab = link.classList.contains("fbo-new-tab");
                Foundation.libs.matyWeglot.redirectUser(decodedUrl, newTab);
            }
        },

        redirectUser: (url, blank = false) => {
            const formattedUrl = Foundation.libs.matyWeglot.adaptUrlToLang(url);

            if (blank) {
                window.open(formattedUrl, "_blank");
            } else {
                window.location.href = formattedUrl;
            }
        },

        adaptUrlToLang: (url) => {
            Foundation.libs.matyWeglot.initCurrentLang();
            Foundation.libs.matyWeglot.initLangCookie(0, 1, 100, null);

            // Si on est en fran�ais ou si c'est une ancre, pas besoin de traitement
            if (!currentLang || currentLang == "fr" || url.startsWith("#")) { return url }

            let newUrl = "";
            let isInternalUrl = false;

            // On regarde si �a utilise un lien relatif, dans quel cas on sait qu'on navigue dans le site, donc on ajoute la langue au d�but
            if (url.startsWith("/")) {
                isInternalUrl = true;
                newUrl = "/" + currentLang + url;
            }
            else {
                // On d�finit la liste des domaines internes du site
                const acceptedInternalDomains =
                    [
                        "www.maty.com",
                        "www1.maty.com",
                        "www2.maty.com",
                        "www3.maty.com",
                        "www4.maty.com",
                        "www5.maty.com",
                        "preprod.maty.com",
                        "dev.maty.com",
                        "int.maty.local",
                        "recette.maty.com",
                        "nimodev",
                        "nimomain",
                        "nimosliders"
                    ]

                // Permet de d�finir le format du lien utilis� ex : https://www.maty.com
                if (url.startsWith("http")) {
                    const formattedUrl = (new URL(url));

                    // Si le domaine de l'url fait parti de la liste d�finie au dessus on renseigne la langue
                    if (formattedUrl && acceptedInternalDomains.includes(formattedUrl.hostname)) {
                        isInternalUrl = true;
                        newUrl = `${formattedUrl.protocol}//${formattedUrl.hostname}/${currentLang}${formattedUrl.pathname}`;
                    }
                }
                // Ou alors c'est du format ex : www.maty.com
                else {
                    // On vient check si l'un des domaines de la liste du dessus est pr�sent dans notre url
                    const index = acceptedInternalDomains.findIndex(el => url.includes(el));

                    if (index != -1) {
                        isInternalUrl = true;
                        const domain = acceptedInternalDomains[index];
                        const destination = url.split(domain)[1];
                        newUrl = `${domain}/${currentLang}${destination}`;
                    }
                }
            }

            // Si c'est une url interne on retourne l'url avec la langue, autrement on laise passer car il s'agit d'un lien sortant
            return isInternalUrl ? newUrl : url;
        },

        adaptStringToLang: async (stringToTranslate, to = "en", from = "fr") => {
            const lang = window.Foundation.libs.matyWeglot.getLangCookie();

            if (lang != "fr") {
                try {
                    to = lang;
                    const params = new URLSearchParams({ stringToTranslate, to, from }).toString();
                    const response = await fetch("/base/adaptStringToLang?" + params);

                    if (!response.ok) throw new Error(response.text());

                    const data = await response.text();

                    if (data) return data;

                } catch (e) {
                    console.error(e);
                }
            }

            return stringToTranslate;
        }
    }
}
    (jQuery, this, this.document));